// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d49e6ef0","455":"e46e1705","977":"9ef104e4"}[chunkId] + ".chunk.js";
};